import { TemplatePortal } from '@angular/cdk/portal';

export enum PortalTemplate {
  HeaderPortal,
}

export type PortalPayload = Map<PortalTemplate, TemplatePortal<any> | null>;
